import React, { Component } from 'react';

import { BookingForm, StorageHandler, APIHandler } from 'C4';
import { storageKeys, baseAppId } from 'settings';
import { Redirect } from 'react-router-dom';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = Array.from(selects);

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  // console.log('inputs', inputs);

  const emptyFields = [];
  inputs.forEach(function(input) {
    if (input.checkValidity() === false) {
      const name = input.name.replace(/reg_/g, '').replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
      emptyFields.push(name);
    }
  });

  selectArray.forEach((select) => {
    if (select.selectedIndex === 0) {
      const name = select.name.replace(/reg_/g, '').replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
      emptyFields.push(name);
    }
  });

  return emptyFields;
};

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  Array.from(selects).forEach((select) => {
    selectArray.push(select);
    // console.log('select', select, select.selectedIndex);
  });

  return (
    inputArray.every((val) => val.checkValidity() === true) &&
    selectArray.every((val) => val.selectedIndex !== 0)
  );
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

class ClearCacheView extends Component {
  constructor() {
    super();
    this.state = {
    };

  }

  componentDidMount() {
    StorageHandler.remove(storageKeys.appInfo);
    window.location.replace('/login')
  }

  render() {
    return (
      <p>
        Clearing cache and redirecting you to login. Please wait.
      </p>
    );
  }
}

export default ClearCacheView;